<template>
  <div class="sn-f-b-s prescription-detail">
    <sn-navigator id="CFCX" :initial="perpetual.FUNCTION_ID_CFXX"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s prescription-detail-region">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_CFXX),
        replace: true,
        router: '/query/prescription'
      }, {
        title: `${$sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_CFXX)}详情`
      }]"></sn-breadcrumb>
      <div class="sn-f-1 detail-blank">
        <div class="card-region" v-if="!$sn.validate.empty(prescriptionDetailInfo)">
          <div class="sn-fs-20 sn-fw-bold sn-fc-main">患者信息</div>
          <div class="sn-f-s-c patient-info" v-if="prescriptionViewMode === '1'">
            <div v-if="prescriptionDetailInfo.patName">患者姓名：{{ prescriptionDetailInfo.patName }}</div>
            <div v-if="prescriptionDetailInfo.patSex">性别：{{ prescriptionDetailInfo.patSex }}</div>
            <div v-if="prescriptionDetailInfo.patAge">年龄：{{ prescriptionDetailInfo.patAge.toString().replace('岁', '') }}岁</div>
            <div v-if="prescriptionDetailInfo.presPayTime">收费时间：{{ prescriptionDetailInfo.presPayTime }}</div>
          </div>
          <div class="sn-f-s-c patient-info" v-else>
            <div v-if="prescriptionDetailInfo.name">患者姓名：{{ prescriptionDetailInfo.name }}</div>
            <div v-if="prescriptionDetailInfo.sex">性别：{{ prescriptionDetailInfo.sex }}</div>
            <div v-if="prescriptionDetailInfo.age">年龄：{{ prescriptionDetailInfo.age.toString().replace('岁', '') }}岁</div>
            <div v-if="prescriptionDetailInfo.openTime">开方时间：{{ prescriptionDetailInfo.openTime }}</div>
          </div>
          <div class="sn-fs-20 sn-fw-bold sn-fc-main">处方信息</div>
          <template v-if="!$sn.validate.empty(prescriptionInfo)">
            <div class="drug-box" v-for="(item, index) in prescriptionInfo" :key="index">
              <template v-if="prescriptionViewMode === '1'">
                <div class="sn-f-b-s drug-info">
                  <div class="drug-name">
                    <div>{{ item.medName }}<template v-if="item.medUnit">({{ item.medUnit }})</template></div>
                  </div>
                  <div class="drug-quantity">{{ `${item.medAmt}${item.medPack}` }}</div>
                </div>
                <div class="sn-f-b-c drug-freq">
                  <div>用法用量：{{ `${item.medPerDos} ${item.medPerDay} ${item.medUsAge}` }}</div>
                </div>
              </template>
              <template v-else>
                <div class="sn-f-b-s drug-info">
                  <div class="drug-name">
                    <div>{{ item.drugName }}<template v-if="item.drugSpec">({{ item.drugSpec }})</template></div>
                    <div class="drug-btn" v-if="item.drugType === '0'" @click="navigateUrl('instructions', item);">药品说明书</div>
                  </div>
                  <div class="drug-quantity">{{ `${item.drugQuantity}${item.drugUnit}` }}</div>
                </div>
                <div class="sn-f-b-c drug-freq">
                  <div>用法用量：{{ `${item.drugDose}${item.drugDoseUnit} ${item.drugFrequency} ${item.drugUsage}` }}</div>
                </div>
                <div class="sn-f-s-c drug-freq" v-if="item.drugTracCode">
                  追溯码： <span class="sn-fc-main" @click=viewClick(item.drugTracCode)> 查看<span class="iconfont icon-xiangyou"></span></span>
                </div>
              </template>
            </div>
          </template>
          <sn-no-data v-else></sn-no-data>
        </div>
        <sn-no-data v-else></sn-no-data>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import * as ServiceConfig from '@/common/utils/service-config';
import * as Constants from '@/common/utils/constants';
import HomepageMixin from '@/common/mixin/homepage-mixin';

export default {
  mixins: [HomepageMixin],
  components: {},
  data() {
    return {
      perpetual: Constants,
      prescriptionInfo: [],
      prescriptionDetailInfo: {}
    };
  },
  computed: {
    prescriptionViewMode() {
      let mode = 'default';
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_HZSL) mode = '1';
      return mode;
    }
  },
  watch: {},
  created: function() {
    document.title = `${this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_CFXX)}详情`;
    this.$route.meta.title = `${this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_CFXX)}详情`;
    this.prescriptionDetailInfo = this.$sn.utils.getHospitalSessionStorage('Prescription_Info');
    this.handlePrescriptionInfo();
  },
  methods: {
    // 获取处方详情
    handlePrescriptionInfo() {
      if (this.$sn.validate.empty(this.prescriptionDetailInfo)) {
        this.prescriptionInfo = [];
        return false;
      }
      const code = {
        [this.perpetual.HOSPITAL_ID_LCRM]: 'ea3f980b-f839-4064-b4ea-997e62b26769',
        [this.perpetual.HOSPITAL_ID_JNYZ]: 'ecd62b6169104949ad07a0aa34c4d440',
        [this.perpetual.HOSPITAL_ID_HZSL]: '6180e110-8e8b-4cc2-8fc3-136aee5c5861',
        [this.perpetual.HOSPITAL_ID_SDSZL]: 'c88bf144-f0b7-f702-9514-6e45a050e3b0'
      };
      let xml = {
        OrderId: this.prescriptionDetailInfo.orderId
      };
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_HZSL) {
        xml = {
          PlatformId: this.$sn.utils.getPlatformType(),
          PlatformUserId: this.$sn.utils.getOpenId(),
          PatId: this.prescriptionDetailInfo.patId,
          PresNo: this.prescriptionDetailInfo.presNo
        };
      }
      const params = {
        url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), code[this.$sn.utils.getHospitalId()]]),
        method: 'POST',
        header: true,
        data: this.$sn.utils.variableEncryption(this.$sn.format.xml(xml))
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) {
          if (result.data.ResultCode === '0') {
            this.prescriptionInfo = result.data.Data;
          }
          else {
            this.$sn.assembly.toast({ caption: result.data.ResultMsg });
          }
        }
        else {
          this.$sn.assembly.toast({ caption: result?.msg || Messages.C001 });
        }
      });
    },
    viewClick(code) {
      this.$sn.assembly.modal({
        title: '追溯码',
        caption: `${code.replace(/,/g, '<br>')}`,
        captionConfirm: '关闭',
        isCancel: false
      });
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'instructions') {
        const code = {
          [this.perpetual.HOSPITAL_ID_LCRM]: 'bf2727e0-7907-48d5-b72f-3c84c9bd47d3',
          [this.perpetual.HOSPITAL_ID_JNYZ]: '823b05ee-6cc3-492f-b427-f75ed222622a',
          [this.perpetual.HOSPITAL_ID_SDSZL]: '3963561e-4f0d-f4fd-fccc-b7e12057d87f'
        };
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest({
          url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), code[this.$sn.utils.getHospitalId()]]),
          method: 'POST',
          header: true,
          data: this.$sn.utils.variableEncryption(this.$sn.format.xml({
            Data: JSON.stringify({
              drugId: item.drugCode,
              drugName: item.drugName
            }),
            PlatformId: this.$sn.utils.getPlatformType(),
            PlatformUserId: this.$sn.utils.getOpenId(),
            Type: '9'
          }))
        }, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
          this.$sn.assembly.loading(false);
          if (result) {
            if (result.code === 0) {
              if (result.data) {
                if (result.data.ResultCode === '0') {
                  if (result.data.Data && result.data.Data.url) {
                    this.navigateUrl(result.data.Data.url);
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: Messages.C002,
                      isCancel: false
                    });
                  }
                }
                else {
                  this.$sn.assembly.modal({
                    caption: result.data.ResultMsg,
                    isCancel: false
                  });
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: Messages.C002,
                  isCancel: false
                });
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: result.msg,
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: Messages.C001,
              isCancel: false
            });
          }
        });
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.prescription-detail {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: $white;
  left: 0;
  top: 0;

  &-region {
    overflow: hidden;
    height: 100%;

    .detail-blank {
      overflow-y: auto;
      width: 100%;
      padding: 20px 20px 0;

      .card-region {
        width: 100%;
        padding: 24px 24px 0;
        border-radius: 6px;
        box-shadow: 0 0 5px $shadow;

        .patient-info {
          color: $text1;
          margin: 12px 0 16px;
          padding-bottom: 16px;
          border-bottom: 1px solid $border1;

          div {
            margin-left: 20px;
          }

          div:first-child {
            margin-left: 0;
          }
        }

        .drug-box {
          margin-top: 12px;
          padding-bottom: 12px;

          &:not(:last-child) {
            border-bottom: 1px dotted $border1;
          }

          .drug-info {
            .drug-name {
              display: flex;
              flex: 1;

              .drug-btn {
                padding: 2px 8px;
                border-radius: 6px;
                border: 1px solid $main;
                font-size: 12px;
                color: $main;
                margin: 0 12px;
                cursor: pointer;
              }
            }
          }

          .drug-freq {
            margin-top: 6px;
            font-size: 14px;
            color: $text6;

            .icon-xiangyou {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
